import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import LogsNavigator from "../../../navigation/LogsNavigator";
import styles from "./logs.module.css";

const Logs = () => {
  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/logs/show-admin-action-logs">
              سجل العمليات
            </PageLink>
          </div>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/logs/room-information-efficiency">
              كفاءة الغرف
            </PageLink>
          </div>
        </div>
      </HorizantalBar>
      <LogsNavigator />
    </div>
  );
};

export default Logs;
